/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentLinkLimitsRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetInstrumentLinkLimits.pb'
import {GetInstrumentLinkLimitsResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/internal/GetInstrumentLinkLimits.pb'


export const getInstrumentLinkLimits = (request:GetInstrumentLinkLimitsRequest, options?: CashRequestOptions) => post<GetInstrumentLinkLimitsRequest, GetInstrumentLinkLimitsResponse>("/2.0/cash/get-instrument-link-limits", request, {...options, rejectOnError: true })